import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

const TerminosUsoPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Términos y Condiciones de Uso</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.1. Objeto
            </h2>
            <p>
              Los presentes términos regulan el uso de la plataforma GUARDIÁNSFIT, destinada a la planificación 
              de entrenamientos, registro de métricas físicas y conductuales y seguimiento del progreso 
              físico-mental de los usuarios.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.2. Tipos de Usuario
            </h2>
            <p>En GUARDIÁNSFIT existen tres tipos de usuario:</p>
            <div className="mt-4 grid gap-4">
              <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-primary">
                <p className="font-semibold text-zinc-200">Usuario</p>
                <p className="text-sm text-zinc-400 mt-1">Recibe planes de entrenamiento y registra sus métricas y hábitos.</p>
              </div>
              <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-blue-500">
                <p className="font-semibold text-zinc-200">Entrenador</p>
                <p className="text-sm text-zinc-400 mt-1">Diseña planes, realiza el seguimiento y añade notas sobre los usuarios asignados.</p>
              </div>
              <div className="p-4 bg-zinc-900/50 rounded-lg border-l-4 border-purple-500">
                <p className="font-semibold text-zinc-200">Centro deportivo</p>
                <p className="text-sm text-zinc-400 mt-1">Accede a información estadística agregada para la gestión de sus entrenadores y usuarios.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.3. Registro
            </h2>
            <p>
              El registro en la plataforma exige la aportación de datos veraces y actualizados.
            </p>
            <p className="mt-4">El usuario es responsable de:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Mantener la confidencialidad de sus credenciales de acceso.</li>
              <li>No permitir el uso de su cuenta por terceros no autorizados.</li>
              <li>Notificar cualquier uso indebido o acceso no autorizado.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.4. Suscripciones
            </h2>
            <p>
              Determinadas funcionalidades de GUARDIÁNSFIT pueden requerir una suscripción de pago.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>El pago se realiza de forma periódica mediante el medio elegido por el usuario.</li>
              <li>La falta de pago podrá dar lugar a la suspensión temporal o bloqueo de la cuenta, de acuerdo con la cláusula de bloqueo.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.5. Prohibiciones
            </h2>
            <p>Quedan expresamente prohibidas las siguientes conductas:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li className="text-red-400">Falsificación o manipulación de métricas o datos de rendimiento.</li>
              <li className="text-red-400">Suplantación de identidad de personas usuarias, entrenadores o terceros.</li>
              <li className="text-red-400">Publicación de contenido inapropiado, ofensivo, difamatorio o ilegal.</li>
              <li className="text-red-400">Cualquier forma de ingeniería inversa, descompilación o intento de acceso al código fuente de la plataforma.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.6. Terminación de la Cuenta
            </h2>
            <p>La cuenta podrá darse por terminada:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>A petición del propio usuario (cancelación voluntaria).</li>
              <li>Por decisión del titular de la plataforma en caso de incumplimientos graves o reiterados de los presentes términos, de la política de privacidad o de otras normas internas, de acuerdo con la cláusula específica de bloqueo y suspensión.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4.7. Jurisdicción
            </h2>
            <p>
              En caso de conflicto, será de aplicación la jurisdicción indicada en el Aviso Legal: Juzgados y 
              Tribunales de Ceuta, sin perjuicio de los derechos irrenunciables que correspondan a los consumidores.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default TerminosUsoPage;
